import { render, staticRenderFns } from "./default-page.vue?vue&type=template&id=5f78555f&"
import script from "./default-page.vue?vue&type=script&lang=js&"
export * from "./default-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f78555f')) {
      api.createRecord('5f78555f', component.options)
    } else {
      api.reload('5f78555f', component.options)
    }
    module.hot.accept("./default-page.vue?vue&type=template&id=5f78555f&", function () {
      api.rerender('5f78555f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/default-page.vue"
export default component.exports